import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import useContactos from "features/Contactos/hooks/useContactos"
import { Formik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const proveedorSearchSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    proveedorSelected: Yup.object().required(t("errors.suplierSelect")),
  })

const initialValues = {
  proveedorSearch: "",
  proveedorSelected: null,
}

const LibradoSearchForm = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { toggleShowCreateContacto } = useContactos()

  return (
    // @ts-expect-error TS(2741): Property 'onSubmit' is missing in type '{ children...
    <Formik
      initialValues={initialValues}
      validationSchema={proveedorSearchSchema(t)}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className='p-3 p-fluid p-formgrid p-grid'>
            <div className='pr-0 p-field p-col-12 p-md-9'>
              <label id='proveedorSearch'>
                {t("crear.librado.supplierSelect")}
              </label>
              <FormikAutoComplete
                id='proveedorSearch'
                name='proveedorSearch'
                className='input-add-empresa'
              />
            </div>
            <div className='pl-0 p-field p-col-3 d-flex flex-column justify-content-end'>
              <div className='add-empresa'>
                <CustomButton
                  className='btn-add-empresa'
                  type='submit'
                >
                  {t("crear.librado.selectLabel")}
                </CustomButton>
              </div>
            </div>
            <span
              // @ts-expect-error TS(2322): Type '(paginationNeeded: boolean | undefined, isCl...
              onClick={toggleShowCreateContacto}
              className='cursor-pointer text-gedesco'
            >
              <FontAwesomeIcon icon={["fal", "plus"]} />{" "}
              {t("crear.librado.addSupplierSelect")}
            </span>
          </div>
          <input
            type='text'
            autoComplete='on'
            value=''
            style={{
              display: "none",
              opacity: 0,
              position: "absolute",
              left: "-100000px",
            }}
            readOnly
          />
        </form>
      )}
    </Formik>
  )
}

export default LibradoSearchForm
